module.exports = __webpack_public_path__ + "img/20191127173123345.1005feb2.png";